<template>
    <div class="layout-wrapper layout-content-navbar">
        <div class="layout-container">
            <aside id="layout-menu" class="layout-menu menu-vertical menu bg-menu-theme">
                <div class="app-brand">
                    <router-link to="/" class="app-brand-link">
                        <span class="app-brand-logo demo">
                            <img height="75" width="225" src="https://www.safeworkpro.com.au/img/SafeWorkPro-logo-colour-1.svg" alt="SafeWorkPro" title="" style="max-height: 90px;">
                        </span>
                    </router-link>
                    <a href="javascript:void(0);" class="layout-menu-toggle menu-link text-large ms-auto d-block d-xl-none">
                        <i class="bx bx-chevron-left bx-sm align-middle"></i>
                    </a>

                </div>
                <div class="menu-inner-shadow"></div>
                <Sidebar />

            </aside>

            <div class="layout-page">
                <Navbar @updateMembershipStatus="updateMembershipStatus"/>
                <div class="content-wrapper">
                    <router-view @updateMembershipStatus="updateMembershipStatus" />
                    <Footer />
                </div>
            </div>

        </div>
    </div>
    

    <!-- Overlay -->
    <div class="layout-overlay layout-menu-toggle"></div>
</template>

<script>
    import Sidebar from '../components/Sidebar.vue';
    import Navbar from '../components/Navbar.vue';
    import Footer from '../components/Footer.vue';
    export default {
        name: 'MemberTemplate',
        components: {
            Sidebar,
            Navbar,
            Footer,
        },
        data() {
            return {
                billingCount: 0
            }
        },
        methods: {
            updateMembershipStatus(){
                this.$emit('updateMembershipStatus');
            },
        },
    };
</script>

<style scoped>
    /* Styles specific to Member view */
</style>